import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ROLES } from '@/constants';
import { getCompanyEquipmentOverview } from '@/services/equipmentRequests.service';

export const COMPANY_EQUIPMENT_QUERY_KEY = 'company-equipment';

// Who may open the overview; the server decides per company (an HR officer
// sees only the sectors they staff).
export const COMPANY_EQUIPMENT_ROLES = [
  ROLES.superAdmin,
  ROLES.techAdmin,
  ROLES.admin,
  ROLES.client,
  ROLES.clientOfficer,
  ROLES.hrOfficer,
];

/**
 * One page of the overview. `params` are the panel's query params (filters,
 * `sort*`, `offset` = page, `limit` = page size).
 */
export default function useCompanyEquipmentOverview(companyId, params = {}) {
  return useQuery({
    queryKey: [COMPANY_EQUIPMENT_QUERY_KEY, companyId, 'page', params],
    queryFn: () =>
      getCompanyEquipmentOverview({ ...params, company: companyId }),
    enabled: !!companyId,
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
    retry: false,
  });
}

/**
 * Counters only (`limit: 0`, no rows) for the tile summary; its error also
 * tells the profile whether the caller may see the tile at all.
 */
export function useCompanyEquipmentSummary(companyId, { enabled = true } = {}) {
  return useQuery({
    queryKey: [COMPANY_EQUIPMENT_QUERY_KEY, companyId, 'summary'],
    queryFn: () =>
      getCompanyEquipmentOverview({ company: companyId, limit: 0 }),
    enabled: !!companyId && enabled,
    staleTime: 30 * 1000,
    retry: false,
  });
}
